var map = {
	"./vegitables_0.csv": 590,
	"./vegitables_1.csv": 591,
	"./vegitables_10.csv": 592,
	"./vegitables_11.csv": 593,
	"./vegitables_12.csv": 594,
	"./vegitables_13.csv": 595,
	"./vegitables_14.csv": 596,
	"./vegitables_15.csv": 597,
	"./vegitables_16.csv": 598,
	"./vegitables_17.csv": 599,
	"./vegitables_18.csv": 600,
	"./vegitables_19.csv": 601,
	"./vegitables_2.csv": 602,
	"./vegitables_20.csv": 603,
	"./vegitables_21.csv": 604,
	"./vegitables_22.csv": 605,
	"./vegitables_23.csv": 606,
	"./vegitables_24.csv": 607,
	"./vegitables_25.csv": 608,
	"./vegitables_26.csv": 609,
	"./vegitables_27.csv": 610,
	"./vegitables_28.csv": 611,
	"./vegitables_29.csv": 612,
	"./vegitables_3.csv": 613,
	"./vegitables_30.csv": 614,
	"./vegitables_31.csv": 615,
	"./vegitables_32.csv": 616,
	"./vegitables_33.csv": 617,
	"./vegitables_34.csv": 618,
	"./vegitables_35.csv": 619,
	"./vegitables_36.csv": 620,
	"./vegitables_37.csv": 621,
	"./vegitables_38.csv": 622,
	"./vegitables_39.csv": 623,
	"./vegitables_4.csv": 624,
	"./vegitables_40.csv": 625,
	"./vegitables_41.csv": 626,
	"./vegitables_42.csv": 627,
	"./vegitables_43.csv": 628,
	"./vegitables_44.csv": 629,
	"./vegitables_45.csv": 630,
	"./vegitables_46.csv": 631,
	"./vegitables_47.csv": 632,
	"./vegitables_48.csv": 633,
	"./vegitables_49.csv": 634,
	"./vegitables_5.csv": 635,
	"./vegitables_50.csv": 636,
	"./vegitables_51.csv": 637,
	"./vegitables_52.csv": 638,
	"./vegitables_53.csv": 639,
	"./vegitables_54.csv": 640,
	"./vegitables_55.csv": 641,
	"./vegitables_56.csv": 642,
	"./vegitables_57.csv": 643,
	"./vegitables_58.csv": 644,
	"./vegitables_59.csv": 645,
	"./vegitables_6.csv": 646,
	"./vegitables_60.csv": 647,
	"./vegitables_61.csv": 648,
	"./vegitables_62.csv": 649,
	"./vegitables_63.csv": 650,
	"./vegitables_64.csv": 651,
	"./vegitables_65.csv": 652,
	"./vegitables_66.csv": 653,
	"./vegitables_67.csv": 654,
	"./vegitables_68.csv": 655,
	"./vegitables_69.csv": 656,
	"./vegitables_7.csv": 657,
	"./vegitables_70.csv": 658,
	"./vegitables_71.csv": 659,
	"./vegitables_72.csv": 660,
	"./vegitables_73.csv": 661,
	"./vegitables_74.csv": 662,
	"./vegitables_75.csv": 663,
	"./vegitables_76.csv": 664,
	"./vegitables_77.csv": 665,
	"./vegitables_78.csv": 666,
	"./vegitables_79.csv": 667,
	"./vegitables_8.csv": 668,
	"./vegitables_9.csv": 669,
	"./vegitables_item_list.csv": 670
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 589;


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables ^\.\/.*\.csv$
// module id = 589
// module chunks = 0